import React from "react";
import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { BCPChartMixed } from "../icons/bcp/BCPIcons";

export default function ViewStatsButton(props) {
  const { href, label, size, sx, ...rest } = props;
  const { t } = useTranslation("", { keyPrefix: "pages.leaderboards" });

  return (
    <Button
      focusRipple
      href={href}
      variant="contained"
      color="primary"
      size={size}
      startIcon={<BCPChartMixed />}
      sx={sx}
      {...rest}
    >
      {label || t("viewStatistics")}
    </Button>
  );
}
